// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import download01Icon from "@/assets/icons/download-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Download01IconProps = Omit<IconProps, "name">;

export function Download01Icon(props: Download01IconProps): React.ReactNode {
  return <Icon name={download01Icon} {...props} />;
}
